import { ReactElement } from 'react';

import { EmojiHappyOutline, TagOutline } from '@bonusly/design-system';

import { DecorationTag } from '../types';

const schemas: Record<DecorationTag, { icon: ReactElement; label: string; trigger: string }> = {
	emoji: {
		icon: <EmojiHappyOutline />,
		label: 'emoji_tooltip',
		trigger: ':',
	},
	mention: {
		icon: <TagOutline />,
		label: 'tag_tooltip',
		trigger: '&',
	},
};

export const useDecorationTagSchema = (tag: DecorationTag) => {
	return schemas[tag];
};
